import { Card, CardContent, CardHeader, CardTitle } from '@repo/shadcn';

import { useSupplierDetailsContext } from '@/modules/suppliers/supplier-details/context';
import { formatCurrencyInBDT } from '@/utils';

export const SupplierPaymentStatus = () => {
    const { data } = useSupplierDetailsContext();

    const totalPrice = data?.data?.total_price || 0;
    const totalPaid = data?.data?.total_paid || 0;
    const totalDue = data?.data?.total_due || 0;

    return (
        <Card>
            <CardHeader className="p-4 sm:p-6">
                <CardTitle>Payment Status</CardTitle>
            </CardHeader>
            <CardContent className="grid grid-cols-1 gap-3 p-4 pt-0 sm:grid-cols-3 sm:p-6 sm:pt-0">
                <div className="flex min-w-0 flex-col justify-between rounded-md border border-gray-500 bg-gray-50 px-4 py-4">
                    <span>Total Amount</span>
                    <span className="break-words font-medium">
                        {formatCurrencyInBDT(totalPrice)}
                    </span>
                </div>

                <div className="flex min-w-0 flex-col justify-between rounded-md border border-green-500 bg-green-50 px-4 py-4">
                    <span>Total Paid</span>
                    <span className="break-words font-medium">
                        {formatCurrencyInBDT(totalPaid)}
                    </span>
                </div>

                <div className="flex min-w-0 flex-col justify-between rounded-md border border-orange-500 bg-orange-50 px-4 py-4">
                    <span>Total Due</span>
                    <span className="break-words font-medium">
                        {formatCurrencyInBDT(totalDue)}
                    </span>
                </div>
            </CardContent>
        </Card>
    );
};

SupplierPaymentStatus.displayName = 'SupplierPaymentStatus';
